import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class INDRACookieService {
  private readonly _cookieExist = new BehaviorSubject<boolean>(false);
  readonly cookieExist$ = this._cookieExist.asObservable();

  private readonly _isPerformingCookieLogin = new BehaviorSubject<boolean>(false);
  readonly isPerformingCookieLogin$ = this._isPerformingCookieLogin.asObservable();

  isAward = false;

  constructor() {}

  setCookieExist(value: boolean): void {
    this._cookieExist.next(value);
  }

  setIsAward(value): void {
    this.isAward = value;
  }

  setIsPerformingCookieLogin(value): void {
    this._isPerformingCookieLogin.next(value);
  }
}
